
const incluirLinkRedirecionar = (lista,rota) => {
  return lista.map(item => {
    item.redirecionar = `${rota}/${item.id}`;
    return item;
  });
}

const formataDataBr = (date = null, onlyDate = false) => {
  try {
    if (date === null || date.length < 10) return '-'

    let options = {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric'
    }

    const optionsTime = {
      hour: 'numeric',
      minute: 'numeric',
      second: 'numeric'
    }

    if (!onlyDate) {
      options = Object.assign(options, optionsTime)
    }

    const dateTime = new Date(getDataPadronizada(date))
    return new Intl.DateTimeFormat('pt-BR', options).format(dateTime)
  }catch (e){
    console.log(e);
    return date;
  }
}

function getDataPadronizada (value) {
  // o javascript trata o timestamp de banco de dados de forma nativa
  // por isso essa linha não faz nenhuma mudança de código
  if (value.includes('T')) return value

  return value.replace(/-/g, '/')
}


function formataMoeda (valor) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

  return formatter.format(valor)
}  

function formatarDecimal (valor) {
  const formatter = new Intl.NumberFormat('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });


  return formatter.format(valor)
}

/**
 * Converte strings de moeda brasileira para números decimais.
 */
function converterMoedaParaDecimal(valor) {
  if (typeof valor !== 'string') return valor;
  
  // Regex para identificar o formato: 1.234,56 ou 50,00
  const regexMoeda = /^\d{1,3}(\.\d{3})*(,\d{2})$/;
  
  if (regexMoeda.test(valor)) {
    // Remove pontos, troca vírgula por ponto e converte para número
    return parseFloat(valor.replace(/\./g, '').replace(',', '.'));
  }
  
  return valor;
}

function formatarPercentual(valor) {
  if (valor === null || valor === undefined) {
    return '-'
  }

  return `${Number(valor).toFixed(0)}%`
}

export {
  incluirLinkRedirecionar,
  formataDataBr,
  formataMoeda,
  formatarDecimal,
  converterMoedaParaDecimal,
  formatarPercentual,
}